import { safeDefine } from "../../registration/safe-define.js";
import { MenuGroupLabelElement } from "../../ui/menu/group-label.js";
//#region src/define/ui/menu-group-label.ts
safeDefine(MenuGroupLabelElement);
//#endregion

//# sourceMappingURL=menu-group-label.js.map